import { render } from "./FormPage.vue?vue&type=template&id=ab8ffd4a&scoped=true&lang=pug"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"

import "./FormPage.vue?vue&type=style&index=0&id=ab8ffd4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8ffd4a"]])

export default __exports__